import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import useClickOutside from "@/hooks/utils/useClickOutside";
import { cn } from "@/lib/utils";
import { ExpandIcon, MinimizeIcon } from "lucide-react";
import { ReactNode, useRef } from "react";
import { Button } from "../../ui/button";

type ExpandableCardProps = {
    title: string;
    icon: string;
    children: ReactNode;
    className?: string;
    expandedClassName?: string;
    isExpanded: boolean;
    onExpand: () => void;
    onCollapse: () => void;
};

const ExpandableCard = ({
    title,
    icon,
    children,
    className,
    expandedClassName,
    isExpanded,
    onExpand,
    onCollapse,
}: ExpandableCardProps) => {
    const cardRef = useRef<HTMLDivElement>(null);
    useClickOutside(
        cardRef,
        () => {
            if (isExpanded) onCollapse();
        },
        "ignore-click-outside",
    );

    return (
        <Card
            ref={cardRef}
            className={cn(
                "w-[35vw] px-4 py-2",
                className,
                isExpanded &&
                    cn(
                        "fixed inset-0 z-overlay m-auto h-[60vh] bg-white/10 backdrop-blur-xl transition-all duration-500",
                        expandedClassName,
                    ),
            )}
            variant="dashboard"
        >
            <CardHeader className="flex items-center justify-between pb-1 text-white">
                <CardTitle className="flex items-center gap-2">
                    <img alt="todo" className="h-5 w-5" src={icon} />
                    {title}
                </CardTitle>
                <Button
                    className="px-1 text-white/60 hover:text-white"
                    onClick={() => (isExpanded ? onCollapse() : onExpand())}
                    variant="invisible"
                >
                    {isExpanded ? (
                        <MinimizeIcon className="h-5 w-5" />
                    ) : (
                        <ExpandIcon className="h-5 w-5" />
                    )}
                </Button>
            </CardHeader>
            {children}
        </Card>
    );
};

export default ExpandableCard;
